/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classNames from 'classnames';

interface Props {
  id?: string;
  name: string;
  label: string;
  disabled?: boolean;
  radioValue: number;
  active: boolean;
  onChange: (value: number) => void;
  className?: string;
}

const BasicRadioButton: React.FC<Props> = ({
  id,
  name,
  label,
  disabled = false,
  radioValue,
  active,
  onChange,
  className,
}) => {
  const RadioButtonClass = classNames({ 'radio-btn': true, disabled, 'font-weight-bold': active });
  return (
    <label className={`${RadioButtonClass} ${className || ''}`}>
      <input
        id={id}
        className="radio-btn__radio"
        name={name}
        type="radio"
        onChange={() => onChange(radioValue)}
        checked={active}
        disabled={disabled}
      />
      <span className="radio-btn__radio-custom" />
      <span className="radio-btn__label">{label}</span>
    </label>
  );
};

export default React.memo(BasicRadioButton);
